module.exports = __webpack_public_path__ + "static/media/img_featuredissues-sexting_V2.83f5af33.png";